export default __webpack_public_path__ + "static/media/gift_blue.72d4469e.svg";